// Exports
// -------

export default function getLocationWithState(pathname, location) {
  return {
    pathname,
    state: {
      // 1. Persist `from` state when present
      from: location?.state?.from || location,
    },
  };
}
